import { c as _c } from "react/compiler-runtime";
const ArrowRight = (t0) => {
    const $ = _c(2);
    const { onClick } = t0;
    let t1;
    if ($[0] !== onClick) {
        t1 = <>
      <button aria-label="Go to next slide" className="react-multiple-carousel__arrow react-multiple-carousel__arrow--right focus:outline-none focus-visible:outline-primary" type="button" onClick={onClick}/></>;
        $[0] = onClick;
        $[1] = t1;
    }
    else {
        t1 = $[1];
    }
    return t1;
};
export default ArrowRight;
